const formatDate = (dateString) => {
  // console.log("dateString", dateString);
  if (!dateString) return "N/A";
  const timestamp = Date.parse(dateString); // Parse the ISO string into a timestamp

  // console.log("timestamp", timestamp);
  if (isNaN(timestamp)) {
    // console.error("Invalid Date:", dateString);
    return "Invalid Date";
  }
  // convert to dd mm yy format
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
  // return new Date(timestamp).toLocaleString();
};

export default formatDate